import React from 'react';
import { redirectToOrderProcessingPage } from 'common/utilities/utils';
import {
  getActiveOrderHistoryHeading,
  getActiveOrderHistoryContainerJSX,
} from '../sharedTemplates/activeOrdersViewTemplates';

const ActiveOrdersView = props => {
  return (
    <div className='active-orders au col-12'>
      {getActiveOrderHistoryHeading(props)}

      <div className='active-orders-list col-12'>
        {getActiveOrderHistoryContainerJSX({ ...props, redirectTo: redirectToOrderProcessingPage })}
      </div>
    </div>
  );
};

export default React.memo(ActiveOrdersView);
